import { Direction } from "../../../types/Direction";

type OrderKey = Direction | "Count";

export const order: Record<OrderKey, number> = {
    [Direction.Upstream]: 0,
    [Direction.Downstream]: 1,
    [Direction.Net]: 2,
    Count: 3,
};

export function orderDirections<T extends keyof typeof order>(
    directions: T[],
): T[] {
    return directions.sort((a, b) => order[a] - order[b]);
}
